import { Tag } from 'src/ui/components/Tag/Tag';
import cn from 'classnames';
import styles from './AppointmentStatusTag.module.scss';

interface AppointmentStatusTagI {
  status: string;
  className?: string;
}

export const AppointmentStatusTag = ({
  status,
  className,
}: AppointmentStatusTagI) => {
  const statusMap: Record<string, string> = {
    CREATED: 'CREATED', // 'CREATED' is the status when the appointment is created but not yet confirmed
    PENDING: 'PENDING', // 'PENDING' is the status when the appointment is pending confirmation
    CONFIRMED: 'CONFIRMED', // 'CONFIRMED' is the status when the appointment is confirmed by the client
    CANCELED: 'CANCELED', // 'CANCELLED' is the status when the appointment is cancelled by the client or the salon
    ON_HOLD: 'ON_HOLD', // 'ON_HOLD' is the status when the appointment is on hold, some minutes after the appointment starts, it's the time to wait for the client.
    IN_PROGRESS: 'IN_PROGRESS', // 'IN_PROGRESS' is the status when the appointment is in progress, the service is currently being provided.
    COMPLETED: 'COMPLETED', // 'COMPLETED' is the status when the appointment is completed
    RESCHEDULED: 'RESCHEDULED', // 'RESCHEDULED' is the status when the appointment is rescheduled by the client or the salon
    EXPIRED: 'EXPIRED', // 'EXPIRED' is the status when the appointment is expired, some minutes after the appointment starts, it's the time to wait for the client.
  };

  return (
    <Tag
      icon="info"
      iconPosition="right"
      text={status}
      className={cn(styles.root, styles[statusMap[status]], className)}
    />
  );
};
